import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage"
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBy3621jg2tKUffqF56--Iwpxfsy2E1F3Y",
  authDomain: "omnes-immigration-app.firebaseapp.com",
  projectId: "omnes-immigration-app",
  storageBucket: "omnes-immigration-app.appspot.com",
  messagingSenderId: "176154941246",
  appId: "1:176154941246:web:f8ce488ce45fa23a343e6f",
  measurementId: "G-VJ9EQV8ED6",
};

firebase.initializeApp(firebaseConfig);
firebase.firestore();

export default firebase;
